// extracted by mini-css-extract-plugin
export default {"Wrapper":"Info_Wrapper__qwuX6"};